import React from 'react';
import InvoiceCreator from '../components/Fees/InvoiceCreator';
import PermissionGuard from '../components/Auth/PermissionGuard';
import './Invoice.css';

const Invoice: React.FC = () => {
  return (
    <PermissionGuard module="invoices" action="read" fallback={
      <div className="invoice-page">
        <div className="invoice-page-header">
          <h1>Invoice</h1>
          <p>You do not have permission to access this page.</p>
        </div>
      </div>
    }>
      <div className="invoice-page">
        <div className="invoice-page-header">
          <h1>INVOICE</h1>
          <p>Create and generate tax invoice PDFs</p>
        </div>

        <div className="invoice-page-content">
          <InvoiceCreator inline />
        </div>
      </div>
    </PermissionGuard>
  );
};

export default Invoice;
